import { WebMercatorViewport } from '@deck.gl/core'
import { MapState } from '@carto/kepler.gl/reducers'

import { DEFAULT_MAP_INDEX, LayerExtent, SplitMapPanelSide } from 'features/builder/types'

export function getMapPanelSide({ mapIndex, isMobile }: { mapIndex: number; isMobile: boolean }): SplitMapPanelSide {
  if (isMobile) {
    return mapIndex === DEFAULT_MAP_INDEX ? 'top' : 'bottom'
  }
  return mapIndex === DEFAULT_MAP_INDEX ? 'left' : 'right'
}

export function zoomBetweenLimits(visibilityByZoom: { min: number; max: number } | undefined, zoom: number) {
  if (visibilityByZoom) {
    const roundedZoom = Math.round(zoom)
    const currentZoomUnderMin = roundedZoom < visibilityByZoom?.min
    const currentZoomOverMax = roundedZoom > visibilityByZoom?.max
    if (currentZoomUnderMin || currentZoomOverMax) {
      return false
    }
  }
  return true
}

export const lngLatToXY = (mapState, lngLat: number[]): { x: number; y: number } | null => {
  const viewport = new WebMercatorViewport(mapState)
  const screenCoord = !viewport || !lngLat ? null : viewport.project(lngLat)
  return screenCoord && { x: screenCoord[0], y: screenCoord[1] }
}

export const xyToLngLat = (mapState: MapState, x: number, y: number): { lng: number; lat: number } | null => {
  const viewport = new WebMercatorViewport(mapState)
  if (!viewport) return null

  const lngLat = viewport.unproject([x, y])
  return lngLat && { lng: lngLat[0], lat: lngLat[1] }
}

export const fitBounds = ({
  extent,
  mapState,
  padding = 54
}: {
  extent: LayerExtent
  mapState: MapState
  padding?: number
}) =>
  new WebMercatorViewport(mapState).fitBounds(
    [
      [extent.xmin, extent.ymin],
      [extent.xmax, extent.ymax]
    ],
    { padding }
  )
